var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConferencesAndMeetings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#94A4F8",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3028 13.9268H10.6987C10.379 13.9268 10.1201 14.1611 10.1201 14.4505V21.6947C10.1201 21.9837 10.379 22.2175 10.6987 22.2175H21.303C21.6229 22.2175 21.8816 21.9837 21.8816 21.6947V14.4505C21.8814 14.1611 21.6227 13.9268 21.3028 13.9268ZM13.9394 21.2302H11.1339V18.3592H13.9394V21.2302ZM13.9394 17.7014H11.1339V14.8305H13.9394V17.7014ZM17.4714 21.2302H14.6659V18.3592H17.4712V21.2302H17.4714ZM17.4714 17.7014H14.6659V14.8305H17.4712V17.7014H17.4714ZM21.1345 21.2302H18.3292V18.3592H21.1345V21.2302ZM21.1345 17.7014H18.3292V14.8305H21.1345V17.7014Z",
    fill: "#EFF1FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2188 9.87842H21.7127V10.7941C21.7127 11.4055 21.2154 11.903 20.6039 11.903C19.9926 11.903 19.4951 11.4055 19.4951 10.7941V9.87842H12.5056V10.7941C12.5056 11.4055 12.0081 11.903 11.397 11.903C10.7853 11.903 10.288 11.4055 10.288 10.7941V9.87842H9.78215C8.9835 9.87842 8.33594 10.5258 8.33594 11.3245V22.508C8.33594 23.3065 8.9835 23.9539 9.78215 23.9539H22.2188C23.0174 23.9539 23.665 23.3065 23.665 22.508V11.3245C23.665 10.5258 23.0174 9.87842 22.2188 9.87842ZM21.881 21.6954C21.881 21.9844 21.6223 22.2183 21.3024 22.2183H10.6983C10.3786 22.2183 10.1197 21.9844 10.1197 21.6954V14.4512C10.1197 14.1619 10.3786 13.9275 10.6983 13.9275H21.3026C21.6225 13.9275 21.8812 14.1619 21.8812 14.4512V21.6954H21.881Z",
    fill: "#94A4F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3974 11.3239C11.6897 11.3239 11.9276 11.0862 11.9276 10.7935V9.87789V8.57611C11.9276 8.2835 11.6898 8.0459 11.3974 8.0459C11.105 8.0459 10.8672 8.28333 10.8672 8.57611V9.87789V10.7935C10.8672 11.0862 11.105 11.3239 11.3974 11.3239Z",
    fill: "#94A4F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6036 11.3239C20.8961 11.3239 21.1338 11.0862 21.1338 10.7935V9.87789V8.57611C21.1338 8.2835 20.8961 8.0459 20.6036 8.0459C20.3112 8.0459 20.0732 8.28333 20.0732 8.57611V9.87789V10.7935C20.0732 11.0862 20.3112 11.3239 20.6036 11.3239Z",
    fill: "#94A4F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9393 14.8306H11.1338V17.7015H13.9393V14.8306Z",
    fill: "#94A4F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4704 14.8306H14.665V17.7015H17.4704V14.8306Z",
    fill: "#94A4F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9393 18.3599H11.1338V21.2308H13.9393V18.3599Z",
    fill: "#94A4F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4704 18.3599H14.665V21.2308H17.4704V18.3599Z",
    fill: "#94A4F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1345 14.8306H18.3291V17.7015H21.1345V14.8306Z",
    fill: "#94A4F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1345 18.3599H18.3291V21.2308H21.1345V18.3599Z",
    fill: "#94A4F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConferencesAndMeetings);
export default __webpack_public_path__ + "static/media/Conferences-and-meetings.30beec96.svg";
export { ForwardRef as ReactComponent };